import type { CompanyICPDto } from "shared";
import { useEventCallback } from "usehooks-ts";
import { useCompanyActions } from "../../company/useCompany";

export const useCompanyIcpActions = () => {
	const { updateCompanyICP } = useCompanyActions();

	const handleContentUpdate = useEventCallback(
		(icp: CompanyICPDto, content: string) => {
			return updateCompanyICP.mutateAsync({
				id: icp.id,
				profile: content,
				approved: icp.approved,
			});
		},
	);

	const handleApprove = useEventCallback(
		(icp: CompanyICPDto, approved: boolean | null) => {
			return updateCompanyICP.mutateAsync({
				id: icp.id,
				profile: icp.profile,
				approved,
			});
		},
	);

	return {
		handleApprove,
		handleContentUpdate,
	};
};
